import * as React from "react"

// Bootstrap badge variant mapping
const variantToBootstrap = {
  default: "bg-primary text-white border-0",
  secondary: "bg-secondary text-white border-0",
  destructive: "bg-danger text-white border-0",
  outline: "bg-transparent text-dark border border-dark",
}

type BadgeVariant = "default" | "secondary" | "destructive" | "outline"

export interface BadgeProps extends React.HTMLAttributes<HTMLSpanElement> {
  variant?: BadgeVariant
}

function Badge({ className = "", variant = "default", ...props }: BadgeProps) {
  const bsClass = variantToBootstrap[variant] || variantToBootstrap.default
  return (
    <span
      className={`badge rounded-pill ${bsClass} ${className}`.trim()}
      style={{
        fontSize: "0.85em",
        fontWeight: 600,
        padding: "0.35em 0.75em",
        ...props.style,
      }}
      {...props}
    />
  )
}

export { Badge }
